//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** Static Guids used by the Rock application */
export const DefinedType = {
    /** Lists checklist items to be completed by the administrator after installs and updates. */
    AdministratorChecklist: "4BF34677-37E9-4E71-BD03-252B66C9373D",
    /** The apple device models */
    AppleDeviceModels: "DAE31F78-7AB9-4ACE-9EE1-C1E6A734562C",
    /** Guid for the Conflict Profile assessment. */
    AssessmentConflictProfile: "EE7E089E-DF81-4407-8BFA-AD865FA5427A",
    /** Background check package types */
    BackgroundCheckTypes: "BC2FDF9A-93B8-4325-8DE9-2F7B1943BFDF",
    /** Guid for the types of Benevolence Request status (e.g. pending, active, answered, etc.) */
    BenevolenceRequestStatus: "2787B088-D607-4D69-84FF-850A6891EE34",
    /** The types of results for a Benevolence Request */
    BenevolenceResultType: "35FC0225-3DAC-48B4-BDF7-AFDE104FB60E",
    /** Guid for the button html */
    ButtonHtml: "407A3A73-A3EF-4970-B856-2A33F62AC72E",
    /** Guid for Cache Tags */
    CacheTags: "BDF73089-9154-40C1-90E4-74518E9937DC",
    /** GUID for the Campus Status */
    CampusStatus: "840CDA6D-6E81-4EB7-B325-BE708990CCE9",
    /** GUID for the Campus Type */
    CampusType: "8C2260A8-6130-414A-BD32-22743FEAB256",
    /** Guid for the types of chart styles */
    ChartStyles: "FC684FD7-FE68-493F-AF38-1656FBF67E6B",
    /** The check in attendance types */
    CheckInAttendanceTypes: "C0508751-3BDD-40A7-BE37-8AA4FC56E00E",
    /** Guid for check-in search type */
    CheckinSearchType: "1EBCDB30-A89A-4C14-8580-8289EC2C7742",
    /** The types of static color swatches supported */
    ColorPickerSwatches: "CC1400B3-E161-45E3-BF49-49825D3D6467",
    /** The types of communication supported (i.e. email, sms, twitter, app-push, etc) */
    CommunicationMedium: "DC8A841C-E91D-4BD4-A6A7-0DE765308E8F",
    /** The list of phone country code formats and how to format their numbers  */
    CommunicationPhoneCountryCode: "45E9EF7C-91C7-45AB-92C1-1D6219293847",
    /** The domains that are safe to send from */
    CommunicationSafeSenderDomains: "DB91D0E9-DCA6-45A9-8276-AEF032BE8AED",
    /**
     * The list of values that SMS messages can be sent from.  Depending on provider, these may
     * be phone numbers or short codes.
     * 
     * The DefinedValue.Value will be the SMS Phone Number( or ShortCode). For example, '+16235551234'. 
     * 
     * The DefinedValue.Description will just be any description, such as 'Rock Solid Church SMS Number'.
     */
    CommunicationSmsFrom: "611BDE1F-7405-4D16-8626-CCFEDB0E62BE",
    /** Guid for Content Channel Audience Type */
    ContentChannelAudienceType: "799301A3-2026-4977-994E-45DC68502559",
    /** The content component template */
    ContentComponentTemplate: "313B579F-F442-4247-ADBB-BBD25E255003",
    /** Guid for data automation ignored person attributes */
    DataAutomationIgnoredPersonAttributes: "886CDB4E-ED8B-48DD-A4CC-D615E032E622",
    /** Guid for Device Type */
    DeviceType: "0368B637-327A-4F5E-80C2-832079E482EE",
    /** Guid for the DISC Results of personalities. */
    DiscResultsType: "F06DDAD8-6058-4182-AD0A-B523BB7A2D78",
    /** Guid for the Domains Sharing Logins */
    DomainsSharingLogins: "6CE00E1B-FE09-45FE-BD9D-56C57A11BE1A",
    /** Guid for Entity Set Purpose */
    EntitySetPurpose: "618BBF3F-794F-4FF9-9615-9211CDBAF723",
    /** Guid for External Application */
    ExternalApplication: "1FAC459C-5F62-4E7C-8933-61FF9FE2DFEF",
    /** Guid for a group's (Family's) status for GroupType of Family */
    FamilyGroupStatus: "792C6979-0F40-47C5-BD0C-06FA7DF22837",
    /** Guid for Financial Currency Type */
    FinancialAccountType: "752DA126-471F-4221-8503-5297593C99FF",
    /** Guid for Financial Credit Card Type */
    FinancialCreditCardType: "2BD4FFB0-6C7F-4890-8D08-00F0BB7B43E9",
    /** The financial currency code */
    FinancialCurrencyCode: "B9F3D359-4365-4594-BCEE-D23FA824FB81",
    /** Guid for Financial Currency Type */
    FinancialCurrencyType: "1D1304DE-E83A-44AF-B11D-0C66DD600B81",
    /** Guid for Financial Frequency  */
    FinancialFrequency: "1F645CFB-5BBD-4465-B9CA-0D2104A1479B",
    /** Defined Type of Non-Cash Assets (used with FinancialTransaction.NonCashAssetTypeValueId. */
    FinancialNoncashAssetType: "6B19C65E-FF8F-4ADD-9DA0-48E53FC074A6",
    /** Guid for Financial Source Type */
    FinancialSourceType: "4F02B41E-AB7D-4345-8A97-3904DDD89B01",
    /** Guid for Financial Transaction Type */
    FinancialTransactionRefundReason: "61FE3A58-9F4F-472F-A4E0-5116EB90A323",
    /** Guid for Financial Transaction Type */
    FinancialTransactionType: "FFF62A4B-5D88-4DEB-AF8F-8E6178E41FE5",
    /** Guid for Fundraising Opportunity Type (Trip, Project, Internship, etc) */
    FundraisingOpportunityType: "53C8FFF6-3022-4A2D-9BAE-FD3435BEA43D",
    /** Guid for the types of Group Locations (such as Home, Main Office, etc) */
    GroupLocationType: "2E68D37C-FB7B-4AA5-9E09-3785D52156CB",
    /** The group RSVP decline reason. */
    GroupRsvpDeclineReason: "1E339D24-3DF3-4628-91C3-DA9300D21ACE",
    /** The group schedule decline reason */
    GroupScheduleDeclineReason: "70C9F9C4-20CC-43DD-888D-9243853A0E52",
    /** The grouptype inactive reason */
    GrouptypeInactiveReasons: "EB5D9839-F770-4E22-8B56-0B09397307D9",
    /** Guid for GroupType Purpose */
    GrouptypePurpose: "B23F1E45-BC26-4E82-BEB3-9B191FE5CCC3",
    /** Guid for the types of interaction service. */
    InteractionChannelMedium: "9bf5777a-961f-49a8-a834-45e5c2077967",
    /** Guid for the JSON Web Token Configuration */
    JwtConfiguration: "7D848CE3-F039-4CE1-A59B-F0D923F0C1A7",
    /** Languages */
    Languages: "6060ba8b-4085-4a29-bf19-a4862b95556a",
    /** Guid for Default link list */
    LavaShortcodes: "3B1AF656-7AEF-52A8-4E2C-5EFF75A1A23A",
    /** Used to store various liquid templates for features in Rock. */
    LavaTemplates: "C3D44004-6951-44D9-8560-8567D705A48B",
    /** Guid for Default link list */
    LinklistDefaultList: "7E7969BD-945C-4472-8A80-889EF5833776",
    /** Guid for the types of States that can be tied to a Location's address. */
    LocationAddressState: "C3A20D2D-AEAF-4E2B-A1D9-2E072CEFC2BB",
    /** Guid for countries */
    LocationCountries: "D7979EA1-44E9-46E2-BF37-DDAF7F741378",
    /** Guid for the types of named locations (such as Campus, Building, Room, etc) */
    LocationType: "3285DCEF-FAA4-43B9-9338-983F4A384ABA",
    /** Logging Domain. */
    LoggingDomains: "60487370-DE7E-4962-B58F-1865303F0414",
    /** The map markers */
    MapMarkers: "80DC21DE-A2C2-42DF-880B-FA9CABD504A0",
    /** Guid for the types of map styles */
    MapStyles: "4EF89471-C049-49ED-AB50-677F689A4E4E",
    /** Guid for Content Channel Audience Type (formally called Marketing Campaign) */
    MarketingCampaignAudienceType: "799301A3-2026-4977-994E-45DC68502559",
    /** Metric Source Type */
    MetricSourceType: "D6F323FF-6EF2-4DA7-A82C-61399AC1D798",
    /** Motivator Theme Type */
    MotivatorThemeType: "354715FA-564A-420A-8324-0411988AE7AB",
    /** Motivator Type */
    MotivatorType: "1DFF1804-0055-491E-9559-54EA3F8F89D1",
    /** Guid for the types of possible check-in system ability levels (such as Infant, Crawler, etc.) */
    PersonAbilityLevelType: "7BEEF4D4-0860-4913-9A3D-857634D1BF7C",
    /** Guid for the person's connection status (such as member, attendee, participant, etc.) */
    PersonConnectionStatus: "2e6540ea-63f0-40fe-be50-f2a84735e600",
    /** A person's ethnicity */
    PersonEthnicity: "79C8AA9A-507C-454B-AFC8-7A9464298A6E",
    /** Guid for the types of Person Marital Statuses (such as Married, Single, Divorced, Widowed, etc.) */
    PersonMaritalStatus: "b4b92c3f-a935-40e1-a00b-ba484ead613b",
    /** Guid for the types of Person phone numbers (such as Primary, Secondary, etc.) */
    PersonPhoneType: "8345DD45-73C6-4F5E-BEBD-B77FC83F18FD",
    /** A person's race */
    PersonRace: "A6E2518F-8DBB-4C60-BA17-05768EC68EA5",
    /** Guid for the types of Person Record Statuses (such as active, inactive, pending, etc.) */
    PersonRecordStatus: "8522badd-2871-45a5-81dd-c76da07e2e7e",
    /** Guid for the types of Person Record Status Reasons (such as deceased, moved, etc.) */
    PersonRecordStatusReason: "e17d5988-0372-4792-82cf-9e37c79f7319",
    /** Guid for the types of Person Records (such as person, business, etc.) */
    PersonRecordType: "26be73a6-a9c5-4e94-ae00-3afdcf8c9275",
    /** Guid for the reasons a person record needs to be reviewed */
    PersonReviewReason: "7680C445-AD69-4E5D-94F0-CBAA96DB0FF8",
    /** Guid representating the person key types to search. */
    PersonSearchKeys: "61BDD0E3-173D-45AB-9E8C-1FBB9FA8FDF3",
    /** Guid for the types of Person Suffixes (such as Jr., Sr., etc.) */
    PersonSuffix: "16f85b3c-b3e8-434c-9094-f3d41f87a740",
    /** Guid for the types of Person Titles (such as Mr., Mrs., Dr., etc.) */
    PersonTitle: "4784cd23-518b-43ee-9b97-225bf6e07846",
    /** The personal device platform type (ios, android, etc). */
    PersonalDevicePlatform: "A55849D7-5C7B-4B36-9024-A672169E4C9C",
    /** Guid for the types of possible personal devices used for notifications */
    PersonalDeviceType: "C1848F4C-D6F8-4514-8DB6-CD3C19621025",
    /** The PowerBI Accounts Defined Type guid */
    PowerbiAccounts: "497DE3E6-66BD-D4A1-4A41-78A2FED2D0DF",
    /** Guid for the types of Projects (such as In-Person, Project Due, etc.) */
    ProjectType: "B7842AF3-6F04-495E-9A6C-F403D06C02F3",
    /** Protect My Ministry MVR jurisdiction codes */
    ProtectMyMinistryMvrJurisdictionCodes: "2F8821E8-05B9-4CD5-9FA4-303662AAC85D",
    /** The REST allowed domains */
    RestApiAllowedDomains: "DF7C8DF7-49F9-4858-9E5D-20842AF65AD8",
    /** The schedule type */
    ScheduleType: "831648D4-2E2C-4940-8358-9B426AEDB460",
    /** The school grades defined type, which has values that determine which grade the person is based. The Value of the DefinedValue is the GradeOffset. */
    SchoolGrades: "24E5A79F-1E62-467A-AD5D-0D10A2328B4D",
    /** The section types defined type, which has values that determine the CSS class to apply to the section div. */
    SectionType: "A72D940B-2A69-44B8-931C-7FE99824D84C",
    /** Used to manage the topic options for small groups. */
    SmallGroupTopic: "D4111631-6B42-1CBD-4019-427D6BC6F475",
    /** The Spiritual Gifts */
    SpiritualGifts: "9D9628F0-7FC5-411E-B9DF-740AA17689A0",
    /** The statement generator lava template (Legacy) */
    StatementGeneratorLavaTemplateLegacy: "74A23516-A20A-40C9-93B5-1AB5FDFF6750",
    /** Guid for Structured Content Editor Tools */
    StructuredContentEditorTools: "E43AD92C-4DD4-4D78-9852-FCFAEFDF52CA",
    /** Template */
    Template: "A6E267E2-66A4-44D7-A5C9-9399666CBF95",
    /** Template Block */
    TemplateBlock: "0F8E2B71-985E-44C4-BF5A-2FB1AAF3E183",
    /** Used to manage the workflows that can be launched via a text message. */
    TextToWorkflow: "2CACB86F-D811-4483-98E1-272F1FF8FF5D",
    /** Campus Topic Type */
    TopicType: "41141100-8fc6-44bb-aa36-9778eeda7f62",
    /** Used to manage the lava code that can be launched via webhook. */
    WebhookToLava: "7BCF6434-8B15-49C3-8EF3-BAB9A63B545D",
    /** Used to manage the workflows that can be launched via webhook. */
    WebhookToWorkflow: "7B39BA6A-E7EF-48A6-9EC7-4A0F498D8FDB",
};
